module.exports = __webpack_public_path__ + "static/img/8.4adf60f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/8.png
// module id = a9rQ
// module chunks = 0